import React from "react"
import PropTypes from "prop-types"
import { Box, Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import { useTranslation } from "react-i18next"
import localizationKeys from "../../../i18n/localizationKeys"
import { DialogCancelButton, DialogOKButton, DialogSubTitle } from "./dialogStyles"
import DeleteIcon from "../../trendPage/icon/deleteIcon"

export const RemoveSelectedChannelsDialog = ({open, handleClose, handleKeep, handleDelete}) => {
  const {t} = useTranslation(); 
  return (
    <Dialog onClose={handleClose} open={open}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: "#161a1e",
            height: "200px",
            width: "600px",
            alignItems: "center"
          }}}}
    >
      <DialogTitle sx={{color: "white"}}>{t(localizationKeys.ChannelGroupWillBeEmptyMessage1)}</DialogTitle>
      <DialogSubTitle>{t(localizationKeys.ChannelGroupWillBeEmptyMessage2)}</DialogSubTitle>
      <DialogActions sx={{width: "95%", position: "absolute", bottom: "5px", justifyContent: "space-around"}}>
        <DialogCancelButton onClick={handleClose}>{t(localizationKeys.CancelButtonText)}</DialogCancelButton>
        <Box sx={{width: "400px", display: "flex", justifyContent: "space-evenly"}}>
          <Button sx={{textTransform: "none", color: "#28b6c7"}} onClick={handleKeep}>{t(localizationKeys.ChannelGroupWillBeEmptyKeep)}</Button>
          <DialogOKButton startIcon={<DeleteIcon color="black"/>} onClick={handleDelete}>{t(localizationKeys.ChannelGroupWillBeEmptyDelete)}</DialogOKButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

RemoveSelectedChannelsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  handleKeep: PropTypes.func,
  handleDelete: PropTypes.func,
}